export default "__VITE_ASSET__BKAd1egf__"